import type { ReactNode } from "react";
import { Text, View } from "react-native";
import { EMBER } from "../../onboarding/theme";
import HeaderActions from "./HeaderActions";
import ScreenTitle from "./ScreenTitle";

type Props = {
  title: string;
  subtitle?: string;
  right?: ReactNode;
  showActions?: boolean;
};

export default function ScreenHeader({
  title,
  subtitle,
  right,
  showActions = true,
}: Props) {
  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        marginBottom: 20,
      }}
    >
      <View style={{ flex: 1 }}>
        <ScreenTitle>{title}</ScreenTitle>
        {subtitle ? <ScreenSubtitle>{subtitle}</ScreenSubtitle> : null}
      </View>
      {right ?? (showActions ? <HeaderActions /> : null)}
    </View>
  );
}

function ScreenSubtitle({ children }: { children: string }) {
  return (
    <Text
      className="font-dm-sans"
      numberOfLines={2}
      style={{
        fontSize: 15,
        color: EMBER.colors.textLight,
        lineHeight: 21,
        marginTop: 2,
      }}
    >
      {children}
    </Text>
  );
}
